import { useEffect } from "react";

interface UseZoomOptions {
  excludeSelectors?: string[]; // Selectors of elements to exclude from zoom
  noZoomSelectors?: string[];
}

const useZoom = (options: UseZoomOptions = {}) => {
  const { excludeSelectors = [], noZoomSelectors = [] } = options;

  useEffect(() => {
    const applyZoom = () => {
      // Select all elements with the class 'zoom-container'
      const screenWidth = window?.innerWidth;

      // Do not apply zoom on screens smaller than 768px
      if (screenWidth < 768) {
        return;
      }

      const containers = document.querySelectorAll(".zoom-container");

      containers.forEach((container) => {
        if (!(container instanceof HTMLElement)) return; // Type check

        // Check if the container is in the list of excludeSelectors
        const isExcluded = excludeSelectors.some((selector) =>
          container.matches(selector)
        );

        if (isExcluded) {
          return;
        }

        const isNoZoom = noZoomSelectors.some((selector) =>
          container.matches(selector)
        );

        const screenWidth = window.innerWidth;
        let scale: number;

        if (isNoZoom) {
          scale = screenWidth <= 1367 ? 1 : 1367 / screenWidth;
        } else {
          scale = screenWidth > 1367 ? screenWidth / 1367 : 1;
        }

        container.style.transform = `scale(${scale})`;
        container.style.transformOrigin = "top left";
      });
    };

    // Apply zoom when the page is loaded
    applyZoom();

    // Update zoom when the window resizes
    window.addEventListener("resize", applyZoom);

    // Clean up when the component unmounts
    return () => {
      window.removeEventListener("resize", applyZoom);
    };
  }, [excludeSelectors]); // Hook depends on excludeSelectors
};

export default useZoom;
